import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal"];

  connect() {
    this.downloading = false;
  }

  download(event) {
    event.preventDefault();

    if (this.downloading) return;

    this.downloading = true;
    const url = event.currentTarget.href || event.currentTarget.dataset.url;
    const filename =
      event.currentTarget.dataset.pdfFilename ||
      `programma-${new Date().getTime()}`;

    // Show the modal
    if (this.hasModalTarget) {
      this.modalTarget.showModal();
    }

    // Use fetch to download the PDF
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error("PDF generation failed");
        }
        return response.blob();
      })
      .then((blob) => {
        // Create a download link
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = `${filename}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);

        // Close modal after ensuring download started
        setTimeout(() => {
          if (this.hasModalTarget) {
            this.modalTarget.close();
          }
          this.downloading = false;
        }, 500);
      })
      .catch((error) => {
        console.error("PDF download failed:", error);
        if (this.hasModalTarget) {
          this.modalTarget.close();
        }
        this.downloading = false;
        alert(
          "Er is een fout opgetreden bij het genereren van de PDF. Probeer het opnieuw.",
        );
      });
  }

  closeModal() {
    if (this.hasModalTarget) {
      this.modalTarget.close();
    }
    this.downloading = false;
  }
}
